//@ts-nocheck
const consultantsFilter = () => {
    const consultantsFilterForm = document.querySelector(".js-consultants-filters");
    const consultantArchive = document.querySelector(".js-consultants-archive");
    const consultantList = document.querySelector(".js-consultant-archive-cards-list");
    if(!consultantsFilterForm || !consultantArchive || !consultantList) return;

    const filterWrappers = consultantsFilterForm.querySelectorAll(".js-consultants-filter-wrapper");
    if(filterWrappers.length === 0) return;

    filterWrappers.forEach(wrapper => {
        const dropdownSearchInputWrapper = wrapper.querySelector(".js-consultants-filter-dropdown-search-input-wrapper");
        const dropdownSearchInput = wrapper.querySelector(".js-consultants-filter-dropdown-search-input");
        const dropdown = wrapper.querySelector(".js-consultants-filter-fieldset");
        const dropdownBtn = wrapper.querySelector(".js-consultants-filter-dropdown-btn");
        if(!dropdownSearchInputWrapper || !dropdownSearchInput || !dropdown || !dropdownBtn) return;

        const dropdownOptions = dropdown.querySelectorAll(".js-consultants-filter-field-wrapper");
        if(dropdownOptions.length === 0) return;

        dropdownOptions.forEach(option => {
            const checkbox = option.querySelector(".js-consultants-checkbox");
            const label = option.querySelector(".js-consultants-filter-field-label");
            if(!checkbox) return;
            option.addEventListener("click", (e)=>{
                if(e.target === checkbox || e.target === label) return;
                checkbox.checked = !checkbox.checked;
                const changeEvent = new Event("change", { bubbles: true });
                checkbox.dispatchEvent(changeEvent);
            })
        });

        document.addEventListener("click", (e)=>{
            if(wrapper.contains(e.target)) return;
            wrapper.classList.remove("opened");
        });

        dropdownSearchInput.addEventListener("input", ()=>{
            const searchTerm = dropdownSearchInput.value.toLowerCase();

            dropdownOptions.forEach(option => {
                const label = option.querySelector(".js-consultants-filter-field-label");
                if(!label) return;
                if(label.textContent.toLowerCase().includes(searchTerm)) {
                    option.style.display = "flex";
                } else {
                    option.style.display = "none";
                }
            });
        })

        dropdownSearchInputWrapper.addEventListener("click", (e)=>{
            if(e.target === dropdownBtn) {
                wrapper.classList.toggle("opened");
            } else {
                wrapper.classList.add("opened");
            }

            filterWrappers.forEach(wrp => {
                if(wrp !== wrapper) {
                    const dropdownSearchInput = wrp.querySelector(".js-consultants-filter-dropdown-search-input");
                    const dropdown = wrp.querySelector(".js-consultants-filter-fieldset");
                    if(!dropdownSearchInput || !dropdown) return;

                    wrp.classList.remove("opened");
                }
            });
        })
    });

    consultantsFilterForm.addEventListener("change", async (e) => {
        e.preventDefault();
        const selectedSpecs = [];
        const selectedCons = [];

        const checkboxes = consultantsFilterForm.querySelectorAll(".js-consultants-checkbox");

        checkboxes.forEach(checkbox => {
            if (!checkbox.checked) return;

            if (checkbox.name === "specialty") {
                selectedSpecs.push(parseInt(checkbox.value));

            } else if (checkbox.name = "name") {
                selectedCons.push(parseInt(checkbox.value));
            }
        });
        

        checkboxes.forEach(cb => {
            const specialtyID = cb.getAttribute("data-speciality");
            
            if(specialtyID && !selectedSpecs.includes(parseInt(specialtyID)) && selectedSpecs.length > 0) {
                cb.checked = false;
                selectedCons = selectedCons.filter(cons => cons !== parseInt(cb.value));
                cb.parentElement.classList.add("hide");
            } else {
                cb.parentElement.classList.remove("hide");
            }
        });

        try {
            let formData = new FormData();
            formData.append("action", "llc_load_consultants");
            if(selectedSpecs.length > 0) {
                selectedSpecs.forEach(spec => {
                    formData.append("specialities[]", spec);
                });
            }

            if(selectedCons.length > 0) {
                selectedCons.forEach(cons => {
                    formData.append("consultant_ids[]", cons);
                });
            }
            
            consultantArchive.classList.add("loading");

            const response = await fetch(ajaxurl, {
                method: "POST",
                body: formData,
            });

            const res = await response.json();
            if(res.data) {
                consultantList.innerHTML = res.data;
                consultantArchive.classList.remove("no-results");
            } else {
                consultantArchive.classList.add("no-results");
                consultantList.innerHTML = "";
            }
            
            consultantArchive.classList.remove("loading");
        } catch(e) {
            console.log(e);
            consultantArchive.classList.remove("loading");
        }
    })
};

export default consultantsFilter;